// extracted by mini-css-extract-plugin
module.exports = {"detailWrap":"detail_detailWrap_cJSgc"};